import {Model} from 'MWC';

export default class extends Model {
    constructor() {
        super();

        this.params = {
            city: '',
            hot: '',
            department: '',
            workType: '',
            name: ''
        };
    }

    setParam(value, name) {
        this.params[name] = value;
    }

    getParam(name) {
        return this.params[name];
    }

    getParams() {
        return this.params;
    }

    resetParams() {
        for (const key in this.params) {
            this.params[key] = '';
        }
    }
}
